var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Fragment from '@components/fragment';
import Main from '@components/main';
import NotFoundError from '@components/not-found-error';
import ServerError from '@components/server-error';
import LAYOUT from '@constants/layout';
import Routings from '@lookups/routings';
import styles from './styles.module.scss';
var AppRoutes = function () {
    var leftSidebarRoutes = [];
    var fullwidthRoutes = [
        {
            path: '*',
            element: _jsx(NotFoundError, {})
        }
    ];
    var fullWidthLiteHeaderRoutes = [];
    var fullWidthLiteHeaderNoFooterRoutes = [];
    var containerLiteHeaderNoFooterRoutes = [];
    Routings.map(function (route) {
        var paths = route.paths, scope = route.scope, layout = route.layout;
        paths.map(function (path, index) {
            var element = (_jsx(Fragment, { scope: scope, section: true, skeleton: _jsx("div", { className: styles.emptySkeleton }) }, "".concat(path, "-").concat(index)));
            if (layout && layout === LAYOUT.FULLWIDTH) {
                fullwidthRoutes.push({
                    path: path,
                    element: element
                });
            }
            else if (layout && layout === LAYOUT.FULLWIDTH_LITE_HEADER) {
                fullWidthLiteHeaderRoutes.push({
                    path: path,
                    element: element
                });
            }
            else if (layout && layout === LAYOUT.FULLWIDTH_LITE_HEADER_NO_FOOTER) {
                fullWidthLiteHeaderNoFooterRoutes.push({
                    path: path,
                    element: element
                });
            }
            else if (layout && layout === LAYOUT.CONTAINER_LITE_HEADER_NO_FOOTER) {
                containerLiteHeaderNoFooterRoutes.push({
                    path: path,
                    element: element
                });
            }
            else {
                leftSidebarRoutes.push({
                    path: path,
                    element: element
                });
            }
        });
    });
    var finalRoutes = [
        {
            path: '/',
            element: _jsx(Main, {}),
            children: __spreadArray([], leftSidebarRoutes, true),
            errorElement: _jsx(ServerError, {})
        },
        {
            path: '/',
            element: _jsx(Main, { layout: LAYOUT.FULLWIDTH }),
            children: __spreadArray([], fullwidthRoutes, true),
            errorElement: _jsx(ServerError, {})
        },
        {
            path: '/',
            element: _jsx(Main, { layout: LAYOUT.FULLWIDTH_LITE_HEADER }),
            children: __spreadArray([], fullWidthLiteHeaderRoutes, true),
            errorElement: _jsx(ServerError, {})
        },
        {
            path: '/',
            element: _jsx(Main, { layout: LAYOUT.FULLWIDTH_LITE_HEADER_NO_FOOTER }),
            children: __spreadArray([], fullWidthLiteHeaderNoFooterRoutes, true),
            errorElement: _jsx(ServerError, {})
        },
        {
            path: '/',
            element: _jsx(Main, { layout: LAYOUT.CONTAINER_LITE_HEADER_NO_FOOTER }),
            children: __spreadArray([], containerLiteHeaderNoFooterRoutes, true),
            errorElement: _jsx(ServerError, {})
        }
    ];
    var router = createBrowserRouter(finalRoutes);
    return _jsx(RouterProvider, { router: router });
};
export default AppRoutes;
